export default __webpack_public_path__ + "static/psle-slay-screen-2-82c6e9ed5331b719d55ebe209cd50b67.png";